import styled from 'styled-components';

export default styled.div`
  position: absolute;
  font-size: 12px;
  color: #263238;
  padding-top: 5px;
  right: 0;
  transform: translateX(50%);

  text-align: center;
`;
